<div [class]="cardClasses()">
  <div class="card-body" [class]="bodyClasses()">
    <ng-content></ng-content>
  </div>
</div>
